// import React, { createContext, useContext, useState, useEffect } from "react";
// import { removeSecureItem, setSecureItem, getSecureItem } from "utils/SecureStorage";
// import PropTypes from "prop-types";
// import { useLocation } from "react-router-dom";


// const HierarchyContext = createContext();

// export const HierarchyProvider = ({ children }) => {
//   // ======================
//   // Initial values from sessionStorage
//   // ======================

//   const location = useLocation();

//   useEffect(() => {
//     const path = location.pathname;

//     // Keep hierarchy only for super-admin organization module
//     if (!path.startsWith("/super-admin/organization") && !path.startsWith("/admin/properties/") && 
//         !path.startsWith("/manager/properties/") && !path.startsWith("/concierge/unit/") && !path.startsWith("/user/properties/")) {
//       clearHierarchy();
//     }
//   }, [location.pathname]);

//   const [orgId, setOrgIdState] = useState(
//     getSecureItem("orgId")
//   );

//   const [propertyId, setPropertyIdState] = useState(
//     getSecureItem("propertyId")
//   );

//   const [unitId, setUnitIdState] = useState(
//     getSecureItem("unitId")
//   );

//   // ======================
//   // Set Organization
//   // (Reset property & unit when org changes)
//   // ======================
//   const setOrgId = (id) => {
//     if (id !== orgId) {
//       setSecureItem("orgId", id);
//       removeSecureItem("propertyId");
//       removeSecureItem("unitId");

//       setOrgIdState(id);
//       setPropertyIdState(null);
//       setUnitIdState(null);
//     }
//   };

//   // ======================
//   // Set Property
//   // (Reset unit when property changes)
//   // ======================
//   const setPropertyId = (id) => {
//     if (id !== propertyId) {
//       setSecureItem("propertyId", id);
//       removeSecureItem("unitId");

//       setPropertyIdState(id);
//       setUnitIdState(null);
//     }
//   };

//   // ======================
//   // Set Unit
//   // ======================
//   const setUnitId = (id) => {
//     setSecureItem("unitId", id);
//     setUnitIdState(id);
//   };

//   // ======================
//   // Optional: Clear all (logout)
//   // ======================
//   const clearHierarchy = () => {
//     removeSecureItem("orgId");
//     removeSecureItem("propertyId");
//     removeSecureItem("unitId");

//     setOrgIdState(null);
//     setPropertyIdState(null);
//     setUnitIdState(null);
//   };

//   return (
//     <HierarchyContext.Provider
//       value={{
//         orgId,
//         setOrgId,
//         propertyId,
//         setPropertyId,
//         unitId,
//         setUnitId,
//         clearHierarchy,
//       }}
//     >
//       {children}
//     </HierarchyContext.Provider>
//   );
// };

// // ✅ Fix ESLint error
// HierarchyProvider.propTypes = {
//   children: PropTypes.node.isRequired,
// };

// // Custom hook (clean usage)
// export const useHierarchy = () => useContext(HierarchyContext);

import React, { createContext, useContext, useState, useEffect } from "react";
import {
  removeSecureItem,
  setSecureItem,
  getSecureItem,
} from "utils/SecureStorage";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

const HierarchyContext = createContext();

export const HierarchyProvider = ({ children }) => {
  const location = useLocation();

  // ======================
  // Initial values from storage
  // ======================
  const [orgId, setOrgIdState] = useState(getSecureItem("orgId"));
  const [propertyId, setPropertyIdState] = useState(
    getSecureItem("propertyId")
  );
  const [unitId, setUnitIdState] = useState(getSecureItem("unitId"));

  // ======================
  // SAFE ROUTE CHECK (FIXED)
  // ======================
  useEffect(() => {
    const path = location.pathname;

    // ✅ Allow all hierarchy-related routes
    const isHierarchyRoute =
      path.includes("/organization") ||
      path.includes("/properties") ||
      path.includes("/concierge");

    if (!isHierarchyRoute) {
      clearHierarchy();
    }
  }, [location.pathname]);

  // ======================
  // Set Organization (SAFE)
  // ======================
  const setOrgId = (id) => {
    if (!id || id === orgId) return; // ✅ prevent unnecessary reset

    setSecureItem("orgId", id);

    // Reset dependent data
    removeSecureItem("propertyId");
    removeSecureItem("unitId");

    setOrgIdState(id);
    setPropertyIdState(null);
    setUnitIdState(null);
  };

  // ======================
  // Set Property (SAFE)
  // ======================
  const setPropertyId = (id) => {
    if (!id || id === propertyId) return; // ✅ prevent unnecessary reset

    setSecureItem("propertyId", id);

    // Reset dependent unit
    removeSecureItem("unitId");

    setPropertyIdState(id);
    setUnitIdState(null);
  };

  // ======================
  // Set Unit
  // ======================
  const setUnitId = (id) => {
    if (!id || id === unitId) return;

    setSecureItem("unitId", id);
    setUnitIdState(id);
  };

  // ======================
  // Clear All Hierarchy
  // ======================
  const clearHierarchy = () => {
    removeSecureItem("orgId");
    removeSecureItem("propertyId");
    removeSecureItem("unitId");

    setOrgIdState(null);
    setPropertyIdState(null);
    setUnitIdState(null);
  };

  return (
    <HierarchyContext.Provider
      value={{
        orgId,
        setOrgId,
        propertyId,
        setPropertyId,
        unitId,
        setUnitId,
        clearHierarchy,
      }}
    >
      {children}
    </HierarchyContext.Provider>
  );
};

// ✅ PropTypes
HierarchyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// ✅ Custom hook
export const useHierarchy = () => useContext(HierarchyContext);